module.exports = __webpack_public_path__ + "media/images/icons/outlined/trademark-4a3a7c20cf793df5a9a3d3764ab47a78.svg";